
import { useState } from 'react';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: '무료 카운슬링에서는 어떤내용을 다루나요?',
      answer: '30분동안 당신의 현재상황을 정확히 파악하고 개인별 맞춤 분석을 진행합니다.일본인여성과의 소통에서 겪는 구체적인 어려움을 찾아내고 즉시 적용할 수 있는 해결방안을 제시해드립니다.상담후에는 서비스가입여부를 자유롭게 결정하실 수 있습니다.'
    },
    {
      question: '일본어실력이 부족해도 상담 받을 수 있나요?',
      answer: '물론입니다! 저희 팀은 한국어와 일본어를 모두 완벽하게 구사하므로 언어에 대한 걱정은 전혀 하지마세요.오히려 일본어실력이 부족한 상황에서 효과적으로 소통하는 방법도 함께 알려드립니다.한국어로 편안하게 상담 받으시면 됩니다.'
    },
    {
      question: '연애경험이 적어도 도움 받을 수 있을까요?',
      answer: '연애경험이 적을수록 우리의 서비스는 더욱 도움이 됩니다. 부족한 부분을 함께 파악하면서 수시로 최적의 조언을 전달하므로 경험이 없어도 반주지원을 통해 연애성취로 나아갈 수 있습니다.'
    },
    {
      question: '바쁜 직장인도 참여할 수 있나요?',
      answer: '물론 괜찮습니다. 주 1회 전화미팅은 편하신 날짜로 실시합니다. 또한,채팅 상담은 24시간 언제든지 이용 가능합니다.'
    },
    {
      question: '서비스는 구체적으로 무엇을 합니까?',
      answer: '한일연애와 연애심리학에 정통하고, 또한 한일연애를 경험하고 있는 일본여성과 정기적인 전화와 메시지를 해주시고, 당신의 현재 연애에 대해 최적의 조언을 해드리며 연애성취를 함께 지향하는 서비스입니다.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            자주묻는 질문들
          </h2>
          <p className="text-xl text-gray-600">
            궁금한 점들을 미리 확인해보세요
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-gray-50 rounded-2xl overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 text-left flex items-center justify-between hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <span className="text-lg font-semibold text-gray-900 pr-8">
                  {faq.question}
                </span>
                <i className={`ri-arrow-down-s-line text-2xl text-blue-600 transform transition-transform ${openIndex === index ? 'rotate-180' : ''}`}></i>
              </button>
              
              {openIndex === index && (
                <div className="px-8 pb-6 pt-2">
                  <p className="text-gray-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Removed the contact section as requested */}
      </div>
    </section>
  );
}